module.exports = __webpack_public_path__ + "static/media/Safe-T14.0fc2e4d3.jpg";